import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyBillingPayment = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/billing/payments',

        paymentMethods: [],
        paymentMethodLoading: false,
        paymentMethodsLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        paymentMethods: state => state.paymentMethods,
    },
};
